import { createRouter, createWebHistory } from 'vue-router'
import { checkUser } from '@/constants/global/router'
import tpehealthAppendixPage from '@/pages/tpehealth/appendix.vue'

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: { name: 'tpehealthAppendix' }
  },
  {
    path: '/appendix/tpehealth/:chapter?',
    name: 'tpehealthAppendix',
    component: tpehealthAppendixPage
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'tpehealthAppendix' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async to => {
  let checkList = [checkUser]
  for (let check of checkList) {
    let result = await check(to)
    return result
  }
  return true
})

export default router
